// extracted by mini-css-extract-plugin
export default {"name":"deviceIdFormatted_name__H77NB"};